import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';

const PHOTO_SRC = '/pastors.jpg';

export default function Pastors() {
  const { t } = useI18n();
  const [hasPhoto, setHasPhoto] = useState(true);
  return (
    <section id="pastors" data-testid="pastors-section" className="relative py-24 lg:py-32 bg-[#f5efe3] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="absolute inset-0 translate-x-3 translate-y-3 lg:-inset-3 lg:translate-x-6 lg:translate-y-6 rounded-[2rem] border border-[#d4a63d]/50" />
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden bg-[#2e5340]" data-testid="pastors-photo">
            {hasPhoto ? (
              <img src={PHOTO_SRC} alt={t.pastors.signature} onError={() => setHasPhoto(false)} className="w-full h-full object-cover object-top" />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center text-[#f5efe3]">
                <span className="font-serif-display italic text-7xl text-[#d4a63d]">G &amp; S</span>
                <span className="mt-4 text-xs uppercase tracking-wider-xtra text-[#f5efe3]/60">{t.pastors.photoSoon}</span>
              </div>
            )}
          </div>
        </div>
        <div>
          <span className="text-[#b88a2a] text-xs uppercase tracking-wider-xtra font-medium">{t.pastors.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1f3a2a] mt-4 leading-[1.05]">{t.pastors.title_1} <span className="italic">{t.pastors.title_2}</span></h2>
          {t.pastors.bio.map((p) => (
            <p key={p.slice(0, 40)} className="mt-6 text-[#4a5a4e] text-lg leading-relaxed">{p}</p>
          ))}
          <div className="mt-8 flex flex-wrap items-center gap-6">
            <div>
              <p className="font-serif-display italic text-2xl text-[#1f3a2a]">{t.pastors.signature}</p>
              <p className="text-xs uppercase tracking-wider-xtra text-[#8a7a4e] mt-1">{t.pastors.role}</p>
            </div>
            <a href="#next-steps" data-testid="pastors-say-hello-btn" className="inline-flex items-center gap-2 bg-[#1f3a2a] hover:bg-[#2e5340] text-[#f5efe3] rounded-full h-12 px-6 text-sm font-medium transition-colors">
              {t.pastors.cta} <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
